export const rolesPermissions = [
    {
        role: 'super-admin',
        permissions: [
            {
                type: 'Empresas',
                desc: 'Criar, editar e eliminar.'
            },
            {
                type: 'Utilizadores',
                desc: 'Criar, editar e eliminar.'
            },
            {
                type: 'Clientes',
                desc: 'Consultar, adicionar, editar e eliminar.'
            },
            {
                type: 'Produtos',
                desc: 'Consultar, adicionar, editar e eliminar.'
            },
            {
                type: 'Tipos (Orçamentos)',
                desc: 'Consultar, adicionar, editar e eliminar.'
            },
            {
                type: 'Workflows',
                desc: 'Consultar, adicionar, editar e eliminar.'
            },
            {
                type: 'Estados',
                desc: 'Consultar e editar.'
            },
            {
                type: 'Orçamentos',
                desc: 'Consultar, adicionar, editar e eliminar. Pode aceitar ou rejeitar o orçamento onde está mencionado no workflow de aprovação.'
            },
            {
                type: 'Tipos',
                desc: 'Consultar, adicionar, editar e eliminar.'
            },
            {
                type: 'Impostos',
                desc: 'Consultar, adicionar, editar e eliminar.'
            },
        ]        
    },
    {
        role: 'admin',
        permissions: [
            {
                type: 'Empresas',
                desc: 'Consultar empresas às quais está associado.'
            },
            {
                type: 'Utilizadores',
                desc: 'Consultar os utilizadores que pertencem à mesma empresa. Consultar e editar os dados do seu utilizador. Não pode modificar as suas permissões nem as empresas às quais pertence.'
            },
            {
                type: 'Clientes',
                desc: 'Consultar, adicionar, editar e eliminar todos os clientes que pertencem às suas empresas.'
            },
            {
                type: 'Produtos',
                desc: 'Consultar.'
            },
            {
                type: 'Tipos (Orçamentos)',
                desc: 'Consultar.'
            },
            {
                type: 'Workflows',
                desc: 'Consultar.'
            },
            {
                type: 'Estados',
                desc: 'Consultar.'
            },
            {
                type: 'Orçamentos',
                desc: 'Consultar todos os orçamentos da empresa a que está associado. Criar, editar e eliminar orçamentos dos quais é responsável. Pode aceitar ou rejeitar o orçamento onde está mencionado no workflow de aprovação.'
            },
            {
                type: 'Tipos',
                desc: 'Consultar.'
            },
            {
                type: 'Impostos',
                desc: 'Consultar.'
            },
        ] 
    },
    {
        role: 'basic-user',
        permissions: [
            {
                type: 'Empresas',
                desc: 'Consultar empresas às quais está associado.'
            },
            {
                type: 'Utilizadores',
                desc: 'Consultar os utilizadores que pertencem à mesma empresa. Consultar e editar os dados do seu utilizador. Não pode modificar as suas permissões nem as empresas às quais pertence.'
            },
            {
                type: 'Clientes',
                desc: 'Consultar todos os clientes que pertencem às suas empresas.'
            },
            {
                type: 'Produtos',
                desc: 'Consultar.'
            },
            {
                type: 'Tipos (Orçamentos)',
                desc: 'Consultar.'
            },
            {
                type: 'Workflows',
                desc: 'Consultar.'
            },
            {
                type: 'Estados',
                desc: 'Consultar.'
            },
            {
                type: 'Orçamentos',
                desc: 'Consultar, criar, editar e eliminar orçamentos dos quais é responsável.'
            },
            {
                type: 'Tipos',
                desc: 'Consultar.'
            },
            {
                type: 'Impostos',
                desc: 'Consultar.'
            },
        ] 
    }
]
